export const enum Errors {
  InvalidGrant = 'invalid_grant',
  Unauthorized = 'HTTP_ERROR_401',
}

export const enum BootstrapErrors {
  API_UNSUPPORTED_APP_VERSION = 'api_unsupported_app_version',
  API_UNSUPPORTED_OS_VERSION = 'api_unsupported_os_version',
}
